/* eslint-disable no-restricted-syntax */
import generateAssociatedElementsData from '../utils/generateAssociatedElementsData.js';
import generateEntitiesData from '../utils/generateEntitiesData.js';
import { formatIndicatorData, parseHeader } from '../utils/utils.js';
import {
  getData,
  putData,
  postData,
  deleteData,
} from './index.js';
import { updateIndicator } from './indicators.js';

import {
  DASHBOARDS_GET,
  DASHBOARDS_GET_BY_ID,
  DASHBOARD_POST,
  DASHBOARD_PUT,
  DASHBOARD_DUPLICATE,
  DASHBOARD_LOADING,
  DASHBOARD_DELETE,
  DASHBOARD_ERROR,
  GET_LIST,
  GET_USER,
  SET_TOAST,
  DASHBOARD_UPDATE_ERRORS,
  INDICATOR_RESET,
  DASHBOARDS_UPDATE_FAVORITE,
  INDICATORS_DATA_UPDATING,
} from './types';

const getUser = async (dispatch, search) => {
  const url = `/craft/user/${search}`;
  const response = await getData(DASHBOARD_ERROR, url, dispatch, true);
  if (response.data.user) {
    dispatch({
      type: GET_USER,
      payload: response.data.user,
    });
  }
};

const getDashboardList = async (dispatch) => {
  const url = '/dashboards/list';
  const response = await getData(DASHBOARD_ERROR, url, dispatch, true);
  if (response.data) {
    dispatch({
      type: GET_LIST,
      payload: response.data,
    });
  }
};

const getDashboardById = async (dispatch, id) => {
  const url = `/dashboards/${id}`;
  dispatch({
    type: DASHBOARD_LOADING,
    payload: DASHBOARDS_GET_BY_ID,
  });
  const response = await getData(DASHBOARD_ERROR, url, dispatch, true);
  if (response.data?.dashboard) {
    dispatch({
      type: DASHBOARDS_GET_BY_ID,
      payload: response.data,
    });
  }
};

const getDashboards = async (dispatch, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/dashboards${queryString ? `?${queryString}` : ''}`;
  dispatch({
    type: DASHBOARD_LOADING,
    payload: DASHBOARDS_GET,
  });
  const response = await getData(DASHBOARD_ERROR, url, dispatch, true);
  if (response.data?.dashboards) {
    dispatch({
      type: DASHBOARDS_GET,
      payload: response.data,
    });
  }
};

const createDashboard = async (dispatch, data) => {
  const url = '/dashboards';
  dispatch({
    type: DASHBOARD_LOADING,
    payload: DASHBOARD_POST,
  });

  const payload = { ...data };
  if (payload.lastEditedBy) {
    // console.debug('Setting last editor on CREATE', payload.lastEditedBy);
  } else {
    payload.lastEditedBy = 'N/A';
  }

  const response = await postData(DASHBOARD_ERROR, url, dispatch, payload, true);
  if (response.data?.dashboard) {
    dispatch({
      type: DASHBOARD_POST,
      payload: response.data.dashboard,
    });
  }
  return response;
};

const duplicateDashboard = async (dispatch, id, data) => {
  const url = `/dashboards/duplicate/${id}`;
  dispatch({
    type: DASHBOARD_LOADING,
    payload: DASHBOARD_DUPLICATE,
  });

  const payload = { ...data };
  if (payload.lastEditedBy) {
    // console.debug('Setting last editor on DUPLICATE', payload.lastEditedBy);
  } else {
    payload.lastEditedBy = 'N/A';
  }

  const response = await postData(DASHBOARD_ERROR, url, dispatch, payload, true);
  if (response.data?.dashboard) {
    dispatch({
      type: DASHBOARD_DUPLICATE,
      payload: response.data.dashboard,
    });
  }
  return response;
};

const updateDashboard = async (dispatch, data, id) => {
  const url = `/dashboards/${id}`;
  dispatch({
    type: DASHBOARD_LOADING,
    payload: `${DASHBOARD_PUT}-${id}`,
  });

  const payload = { ...data };
  if (payload.lastEditedBy) {
    // console.debug('Setting last editor on UPDATE', payload.lastEditedBy);
  } else {
    payload.lastEditedBy = 'N/A';
  }

  // Update the dashboard
  const response = await putData(
    DASHBOARD_ERROR,
    url,
    dispatch,
    payload,
    true,
  );

  // If the update was successful, dispatch the DASHBOARD_PUT action and a success toast
  if (response.data?.dashboard) {
    dispatch({
      type: DASHBOARD_PUT,
      payload: response.data,
    });
    dispatch({
      type: SET_TOAST,
      payload: {
        type: 'success',
        message: 'Le dashboard a été modifié',
      },
    });
  }
  return response;
};

async function handleChangeData(options, config, graphType, data) {
  const isAssociatedDb = !!config?.name?.value?.parent;
  let generatedData = null;
  if (!isAssociatedDb) {
    generatedData = await generateEntitiesData(
      options,
      config,
      graphType,
      data,
    );
  } else {
    generatedData = await generateAssociatedElementsData(
      options,
      config,
      graphType,
      data,
    );
  }
  return generatedData;
}

/**
 * Is called when user clicks either button dashboard.updateIndicators or dashboard.update
 * For each indicator, finds the fields, the request and updates the data.
 * Once this is done, actually update the dashboard itself.
 *
 * @param {*} dispatch
 * @param {*} dataset
 * @param {*} dashboard
 * @param {*} isNewKey
 * @param {*} editorName
 * @returns
 */
const updateDashboardData = async (dispatch, dataset, dashboard, isNewKey, editorName) => {
  const errors = [];
  const tasks = [];
  dispatch({
    type: INDICATORS_DATA_UPDATING,
    payload: true,
  });
  // console.debug('Starting updateDashboardData', dashboard.indicators);
  // ITERATE OVER INDICATORS
  dashboard.indicators.forEach((indicator) => {
    if ((isNewKey && indicator.inheritance) || !isNewKey) {
      if (isNewKey && indicator.inheritance) {
        // console.debug('Treating heir indicator', indicator);
      }
      tasks.push(async () => {
        const lang = localStorage.getItem('lang');
        const {
          header, query, graph,
        } = indicator;
        // GET FIELDS
        const config = { ...indicator.config };
        const body = {
          lang,
          key: isNewKey ? dataset?.value : indicator?.key,
          request: isNewKey ? dataset?.api : indicator?.requests,
          header: parseHeader(header),
          query: query ? encodeURI(query) : '',
        };
        const response = await postData(DASHBOARD_ERROR, '/craft/fields', null, body);
        const { fields } = response.data;
        // GET DATAS
        const field = fields?.find(
          (f) => f.value === config?.params?.name,
        );

        // res contains the indicator's raw data that need formatting before being saved
        const res = await postData(DASHBOARD_ERROR, '/craft/request', null, {
          key: isNewKey ? dataset?.value : indicator?.key,
          requests: isNewKey ? dataset?.api : indicator?.requests,
          lang,
          query,
          header: parseHeader(header),
          associatedDomainId: field?.associatedDomainId || false,
          associatedId: field?.associatedId || false,
          startDate: config?.startDate,
          endDate: config?.endDate,
        }).catch((err) => {
          if (err.response) {
            console.log(err.response);
            dispatch({
              type: SET_TOAST,
              payload: {
                type: 'error',
                message: 'toaster.errors.500',
              },
            });
          }
        });

        // If result is empty or non existing, DO NOT PROCEED
        if (res === undefined || res === null) {
          errors.push({
            indicator: indicator.name,
          });
          return;
        }
        const { data } = res.data;
        const options = await formatIndicatorData(data, fields);
        // console.debug('Indicator options', options);
        const name = options?.keys?.find(
          (k) => k.value === config?.params?.name?.value || k.value === config?.params?.name,
        );
        const value = options?.options?.find(
          (k) => k.value === config.params?.value?.value || k.value === config?.params?.value,
        );
        // If we have found a name and a value, proceed
        if (name?.value && value?.value) {
          config.params.name = name;
          config.params.value = value;
          // console.debug('Valid config', config);
          const updatedConfig = {
            ...config,
          };
          // needed to get the labels of the associated lists (and their hierarchy)
          updatedConfig.associatedConfig = {
            api: isNewKey ? dataset?.api : indicator?.requests,
            key: isNewKey ? dataset?.value : indicator?.key,
          };

          // Formats the indicator data into something that's almost ready to be saved as is
          // Why this is done by the front instead of the back, I'm not exactly sure
          const generatedData = await handleChangeData(
            options,
            updatedConfig,
            graph,
            indicator.data,
          );
          if (generatedData.stacked) {
            config.legend.stacked = generatedData.stacked;
          }
          const updatedData = {
            ...indicator,
            key: isNewKey ? dataset?.value : indicator?.key,
            requests: isNewKey ? dataset?.api : indicator?.requests,
            config,
            data: generatedData.data,
          };
          if (generatedData.data.length === 0) {
            // console.debug('generatedData.data is empty', indicator.name);
            // console.debug(name);
            // console.debug(value);
            // Force publication status to false when generated data is empty
            updatedData.isPublished = false;
            errors.push({
              value: config?.params?.name?.value,
              indicator: indicator.name,
            });
          }
          // PUT the data into the saved indicator
          await updateIndicator(dispatch, updatedData, indicator._id);
        } else { // Missing name or value, empty the saved data and throw an error
          // console.debug('Error on indicator', indicator.name);
          const updatedData = {
            ...indicator,
            key: isNewKey ? dataset?.value : indicator?.key,
            requests: isNewKey ? dataset?.api : indicator?.requests,
            // Force publication status to false when missing data
            isPublished: false,
            config,
            data: [],
          };
          // PUT the EMPTY data into the saved indicator
          await updateIndicator(dispatch, updatedData, indicator._id);
          errors.push({
            value: config?.params?.name,
            indicator: indicator.name,
          });
        }
      });
    }
  });
  for await (const task of tasks) {
    try {
      await task();
    } catch (error) {
      console.log(error);
    }
  }
  dispatch({
    type: INDICATOR_RESET,
  });
  // FINALLY update the dashboard itself
  // console.debug('Updating dashboard by editor', editorName);
  await updateDashboard(dispatch, {
    key: dataset?.value,
    requests: dataset?.api,
    lastEditedBy: editorName,
  }, dashboard._id);

  dispatch({
    type: INDICATORS_DATA_UPDATING,
    payload: false,
  });

  if (errors.length > 0) {
    return dispatch({
      type: DASHBOARD_UPDATE_ERRORS,
      payload: errors,
    });
  }
  return dispatch({
    type: DASHBOARD_UPDATE_ERRORS,
    payload: null,
  });
};

const updateFavoriteDashboard = async (dispatch, data) => {
  const url = '/dashboards/favorite';
  dispatch({
    type: DASHBOARD_LOADING,
    payload: DASHBOARDS_UPDATE_FAVORITE,
  });
  const response = await postData(DASHBOARD_ERROR, url, dispatch, data, true);
  if (response.data?.dashboards) {
    dispatch({
      type: DASHBOARDS_UPDATE_FAVORITE,
      payload: response.data.dashboards,
    });
  }
  return response;
};

const deleteDashboard = async (dispatch, id) => {
  const url = `/dashboards/${id}`;
  dispatch({
    type: DASHBOARD_LOADING,
    payload: DASHBOARD_DELETE,
  });
  const response = await deleteData(DASHBOARD_ERROR, url, dispatch, true);
  if (response.status === 200) {
    dispatch({
      type: DASHBOARD_DELETE,
      payload: id,
    });
  }
  return response;
};

export {
  getUser,
  getDashboardList,
  getDashboardById,
  getDashboards,
  createDashboard,
  duplicateDashboard,
  updateDashboardData,
  updateFavoriteDashboard,
  updateDashboard,
  deleteDashboard,
};
